// let host = window.location.host
export const HOME_BANNER_IMAGE = 'https://img01.wanfangche.com/public/upload/201710/26/1508995567554.jpg?x-oss-process=style/large' // 首页头图
export const WECHAT_ZUCHE_PAY = 'https://api.wanfangche.com/rental/public/Pay/Pay/getunionid?url=https://m.wanfangche.com/pay/wechat/?id='
export const WECHAT_RENTAL_PAY = 'https://api.wanfangche.com/rental/public/Pay/Pay/getunionid?url=https://m.wanfangche.com/pay/wechat/?id='

export const ossimage = {
  avatar: '?x-oss-process=style/avatar',
  small: '?x-oss-process=style/small',
  middle: '?x-oss-process=style/middle',
  squareLarge: '?x-oss-process=style/square-large',
  large: '?x-oss-process=style/large',
  xlarge: '_ytsy'
}

export const topics = ['房车家族英雄会', '英雄会摄影大赛', '2018逛房车展', '随手拍房车', '旅行故事', '露营生活', '目的地推荐']

export const maptype = [
  {value: 100000, name: '住宿服务'},
  {value: 100100, name: '宾馆酒店'},
  {value: 100101, name: '六星级以上宾馆'},
  {value: 100102, name: '五星级宾馆'},
  {value: 100103, name: '四星级宾馆'},
  {value: 100104, name: '三星级宾馆'},
  {value: 100105, name: '经济型连锁酒店'},
  {value: 100200, name: '旅馆招待所'},
  {value: 100201, name: '青年旅舍'},
  {value: 110000, name: '旅游景点'},
  {value: 110100, name: '公园广场'},
  {value: 110101, name: '公园'},
  {value: 110102, name: '动物园'},
  {value: 110103, name: '植物园'},
  {value: 110104, name: '水族馆'},
  {value: 110105, name: '城市广场'},
  {value: 110200, name: '风景名胜'},
  {value: 110201, name: '世界遗产'},
  {value: 110202, name: '国家级景点'},
  {value: 110203, name: '省级景点'},
  {value: 110204, name: '纪念馆'},
  {value: 110205, name: '寺庙道观'},
  {value: 110206, name: '教堂'},
  {value: 110207, name: '回教寺'},
  {value: 110208, name: '海滩'},
  {value: 140000, name: '科教文化场所'},
  {value: 140100, name: '博物馆'},
  {value: 140101, name: '奥迪博物馆'},
  {value: 140102, name: '奔驰博物馆'},
  {value: 140200, name: '展览馆'},
  {value: 140300, name: '会展中心'},
  {value: 140400, name: '美术馆'},
  {value: 140500, name: '图书馆'},
  {value: 140600, name: '科技馆'},
  {value: 140700, name: '天文馆'},
  {value: 140800, name: '文化宫'},
  {value: 140900, name: '档案馆'},
  {value: 141000, name: '文艺团体'},
  {value: 141100, name: '传媒机构'},
  {value: 141101, name: '电视台'},
  {value: 141102, name: '电台'},
  {value: 141103, name: '报社'},
  {value: 141104, name: '杂志社'},
  {value: 141105, name: '出版社'},
  {value: 141200, name: '学校'},
  {value: 141201, name: '高等院校'},
  {value: 141202, name: '中学'},
  {value: 141203, name: '小学'},
  {value: 141204, name: '幼儿园'},
  {value: 141205, name: '成人教育'},
  {value: 141206, name: '职业技术学校'},
  {value: 141300, name: '科研机构'},
  {value: 141400, name: '培训机构'},
  {value: 141500, name: '驾校'},
  {value: 180000, name: '道路附属设施'},
  {value: 180100, name: '警示信息'},
  {value: 180101, name: '摄像头'},
  {value: 180102, name: '测速设施'},
  {value: 180103, name: '铁路道口'},
  {value: 180200, name: '收费站'},
  {value: 180201, name: '高速收费站'},
  {value: 180202, name: '国省道收费站'},
  {value: 180203, name: '桥洞收费站'},
  {value: 180300, name: '高速服务区'},
  {value: 180301, name: '高速加油站服务区'},
  {value: 180302, name: '高速停车区'},
  {value: 180400, name: '红绿灯'},
  {value: 180500, name: '路牌信息'},
  {value: 190000, name: '地名地址信息'},
  {value: 190100, name: '行政地名'},
  {value: 190101, name: '国家名'},
  {value: 190102, name: '省'},
  {value: 190103, name: '直辖市'},
  {value: 190104, name: '地市'},
  {value: 190105, name: '区县'},
  {value: 190106, name: '乡镇'},
  {value: 190107, name: '街道'},
  {value: 190108, name: '村庄'},
  {value: 190109, name: '村组'},
  {value: 190200, name: '自然'},
  {value: 190201, name: '海湾'},
  {value: 190202, name: '岛屿'},
  {value: 190203, name: '山'},
  {value: 190204, name: '河流'},
  {value: 190205, name: '湖泊'},
  {value: 190300, name: '地名'},
  {value: 190301, name: '道路'},
  {value: 190302, name: '路口'},
  {value: 190303, name: '环岛名'},
  {value: 190304, name: '高速路出口'},
  {value: 190305, name: '高速路入口'},
  {value: 190306, name: '立交桥'},
  {value: 190307, name: '桥'},
  {value: 190308, name: '城市快速路出口'},
  {value: 190309, name: '城市快速路入口'},
  {value: 190310, name: '隧道'},
  {value: 190400, name: '门牌'},
  {value: 190401, name: '地名门牌'},
  {value: 190402, name: '道路门牌'},
  {value: 190403, name: '小区门牌'},
  {value: 190500, name: '城市中心'},
  {value: 190600, name: '标志性建筑物'},
  {value: 200000, name: '公共设施'},
  {value: 200100, name: '报刊亭'},
  {value: 200200, name: '公用电话'},
  {value: 200300, name: '公共厕所'},
  {value: 200400, name: '紧急避难场所'}
]

export default {
  HOME_BANNER_IMAGE,
  WECHAT_ZUCHE_PAY,
  WECHAT_RENTAL_PAY,
  ossimage,
  feedShareAddon: ' | 21世纪房车', // 房车圈分享后缀
  feedShareImage: 'https://img01.wanfangche.com/public/upload/201711/09/5a03c7697580d.jpg?x-oss-process=style/small', // 房车圈分享默认图片
  maptype
}



// WEBPACK FOOTER //
// ./src/config/index.js